<template>
  <div class="container">
    <!--现金提现-->
    <div class="form-wrap" v-if="withdraw_type == 1">
      <div class="bindcard-wrap">
        <img class="icon-img" src="@/assets/images/icon_bank.png" />
        <span
          >{{ bankInfo.bank_name }}(
          {{ bankInfo.bank_card | regroupBankCard }})</span
        >
      </div>
      <div class="title">提现金额</div>
      <div class="money-wrap">
        <img src="@/assets/images/icon_money_logo.png" />
        <!-- <van-field class="input" v-model="form.money" @blur="blurCheckMoney">
        </van-field> -->
        <div class="rmb-input">
          <input class="input" v-model="form.money" @blur="blurCheckMoney" />
          <div class="btn-out" @click="allMoney">全部转出</div>
        </div>
      </div>
      <div class="tip" v-if="isMoneyError">{{ descTip | '' }}</div>
      <div class="desc">
        钱包余额¥{{ withdrawInfo.money }}(最小提现金额为{{
          withdrawInfo.money_min
        }})
      </div>
    </div>
    <div class="form-wrap" v-else>
      <div class="bindcard-wrap">
        <img class="icon-img" src="@/assets/images/icon_game_logo.png" />
        <span>游戏账号( {{ userInfo.uin }})</span>
      </div>
      <div class="title" @click="allBean">转出数额</div>
      <div class="money-wrap">
        <div class="rmb-input">
          <input class="input" v-model="form.money" @blur="blurCheckBean" />
          <div class="btn-out" @click="allBean">全部转出</div>
        </div>
      </div>
      <div class="tip" v-if="isBeanError">{{ descTip | '' }}</div>
      <div class="desc">最多提现数额{{ withdrawInfo.minibean }}</div>
    </div>
    <div class="bottom-box">
      <div class="submit-btn">
        <div class="content" @click="inputCode">确定提现</div>
      </div>
      <div class="cancel-btn">
        <div class="content" @click="cancel">取消</div>
      </div>
      <div style="display: flex;justify-content: center;margin: 8px auto;" v-if="withdraw_type == 1">
        <van-checkbox v-model="aggrementProtal" checked-color="#fd9b21">
          <span :style="aggrementProtal ? 'color:#fd9b21' : ''">已阅读并同意</span>
          <a style="color: #2b6ddf;" href="https://mnweb.mini1.cn/activity/docs/%E7%81%B5%E6%B4%BB%E5%B0%B1%E4%B8%9A%E5%90%88%E4%BD%9C%E4%BC%99%E4%BC%B4%E5%8D%8F%E8%AE%AE-L20230608-clean.html"
            target="_blank">《灵活就业合作伙伴协议》</a>
        </van-checkbox>
      </div>
      <div class="desc" v-if="withdraw_type == 1">
        由于扣税及手续费等因素，请以实际到账金额为准，详细请查看
        <a href="https://dev-wiki.mini1.cn/news/2069" target="_blank">
          《迷你平台结算规则说明》</a
        >
      </div>
    </div>
    <!--验证码验证-->
    <div class="code-wrap">
      <van-dialog
        v-model="showCode"
        title="安全验证"
        :closeOnClickOverlay="true"
        :show-confirm-button="false"
      >
        <div class="box">
          <div class="code-title">为保证你的账号安全，需进行手机号验证</div>
          <div class="code-desc">
            请输入手机号+86 {{ developerInfo.phone }}上的验证码
          </div>
          <div class="numberInputWrap">
            <vue-input-code
              span-size="20px"
              type="number"
              :number="6"
              height="50px"
              span-color="#000"
              input-color="#000"
              input-size="24px"
              :code="form.vercode"
              :get-input="numberInputChange"
            />
          </div>
          <div class="bottom-desc">
            没有收到？
            <span
              class="btn-code"
              :class="{ 'btn-forbid': isDisabled }"
              @click="getCode"
              >{{ codeTxt }}</span
            >
          </div>
        </div>
        <div class="submit-btn">
          <div class="content" @click="submitApply">确认</div>
        </div>
      </van-dialog>
    </div>
  </div>
</template>

<script>
const checkoutMoney = (money, info) => {
  let reg = /^\d+(\.\d+)?$/;
  let errorMoneyTip = '';
  console.log('money', money);
  if (!money) {
    errorMoneyTip = '提现数额不能为空';
  } else if (!reg.test(money)) {
    errorMoneyTip = '请输入正确的数额';
  } else if (money > info.money) {
    errorMoneyTip = '余额不足，请重新输入';
  } else if (money < info.money_min) {
    errorMoneyTip = `不满最小提现数额(${info.money_min})`;
  } else {
    errorMoneyTip = '';
  }
  return errorMoneyTip;
};
const checkoutCode = code => {
  let errorCodeTip = '';
  if (!code) {
    errorCodeTip = '验证码不能为空';
  } else {
    errorCodeTip = '';
  }
  return errorCodeTip;
};

import { mapState } from 'vuex';
import { withdraw, getSettlementOverview } from '@/api/income';
import { getVercode } from '@/api/common';
import VueInputCode from 'vue-input-code';

export default {
  components: {
    VueInputCode
  },
  data() {
    return {
      moneyTip: '',
      moneyErrorTip: '',
      showKeyboard: false,
      form: {
        money: '',
        vercode: []
      },
      withdraw_type: 1,
      descTip: '',
      showCode: false,
      withdrawInfo: {},
      isMoneyError: false,
      isBeanError: false,
      isDisabled: false,
      codeTxt: '重新发送',
      interId: null, // 定时器,
      aggrementProtal: false
    };
  },
  computed: {
    ...mapState(['userInfo', 'bankInfo', 'developerInfo'])
  },
  filters: {
    regroupBankCard(val) {
      if (val) {
        return val.substring(val.length - 4);
      }
    }
  },
  mounted() {
    this.withdraw_type = this.$route.query.type;
    this.init();
  },
  methods: {
    init() {
      this.fetchSettlementOverview();
    },
    numberInputChange() {
      console.log('numberInputChange', this.form.vercode);
    },
    async fetchSettlementOverview() {
      try {
        const res = await getSettlementOverview({ dtype: 1 });
        this.withdrawInfo = res.data;
        // (this.withdrawInfo.money = 1666), (this.withdrawInfo.minibean = 10000);
        this.isMoneyError = false;
      } catch (error) {
        console.log(error);
      }
    },
    // 获取公共验证码接口
    async fetchGetVercode(phone) {
      if (this.interId) {
        return this.$toast.fail('一分钟内不允许重复发送短信验证码，请稍后重试');
      }
      try {
        await getVercode({ phone, tk: this.userInfo.tk });
        this.$Toast.success('发送成功');
        this.countDown();
      } catch (error) {
        console.log(error);
      }
    },
    // 提现接口
    async fetchWithdraw(data) {
      try {
        const res = await withdraw(data);
        this.$toast.success('已成功发起申请');
        this.showCode = false;
        setTimeout(() => {
          this.$router.push({
            path: '/income/settlement'
          });
        }, 1000);
      } catch (error) {
        console.log(error);
      }
    },
    //检查金额
    blurCheckMoney() {
      this.descTip = checkoutMoney(this.form.money, this.withdrawInfo);
      if (this.descTip) {
        this.isMoneyError = true;
      } else {
        this.isMoneyError = false;
      }
    },
    //检查迷你豆
    blurCheckBean() {
      this.descTip = this.checkoutBean();
      if (this.descTip) this.isBeanError = true;
      else this.isBeanError = false;
    },
    inputCode() {
      //   if(t)
      //判断是否符合要求
      if (this.withdraw_type == 1) {
        this.blurCheckMoney();
        if (this.descTip) this.$toast.fail(this.descTip);
        else {
          if (!this.developerInfo.phone) {
            this.$toast.fail('手机号不可为空');
          } else if (!this.aggrementProtal) {
            this.$toast.fail('请勾选协议');
          }
          else {
            //展示验证码输入框
            this.showCode = true;
            this.getCode();
          }
        }
      } else {
        this.blurCheckBean();
        if (this.descTip) this.$toast.fail(this.descTip);
        else {
          //展示验证码输入框
          this.showCode = true;
          if (!this.developerInfo.phone) this.$toast.fail('手机号不可为空');
          else {
            this.showCode = true;
            this.getCode();
          }
        }
      }
    },
    checkoutBean() {
      let errorMessage = '';
      if (this.form.money > this.withdrawInfo.minibean)
        errorMessage = '数额不足';
      else if (!this.form.money) errorMessage = '提现数额不能为空';
      return errorMessage;
    },
    // 提现
    submitApply() {
      if (!this.form.vercode.length) {
        return this.$toast.fail('验证码不能为空');
      }
      if (this.form.vercode.length < 6) {
        return this.$toast.fail('请输入完整验证码');
      }
      let data = {
        money_type: this.withdraw_type,
        money: this.form.money,
        vercode: this.form.vercode.join('')
      };
      this.fetchWithdraw(data);
    },
    // 获取验证码
    getCode() {
      this.fetchGetVercode(this.developerInfo.phone);
    },
    allMoney() {
      this.isMoneyError = false;
      this.form.money = this.withdrawInfo.money;
    },
    allBean() {
      this.isBeanError = false;
      this.form.money = this.withdrawInfo.minibean;
    },
    cancel() {
      this.$router.push({ name: 'IncomeSettlement' });
    },
    // 倒计时
    countDown() {
      let time = 60;
      this.interId = setInterval(() => {
        time--;
        if (time > 0) {
          this.codeTxt = `重新发送${time}S`;
          this.isDisabled = true;
        } else {
          clearInterval(this.interId);
          this.interId = null;
          this.isDisabled = false;
          this.codeTxt = '重新发送';
        }
      }, 1000);
    },
    blurKey() {
      this.showKeyboard = false;
    }
  }
};
</script>

<style lang="less" scoped>
.container {
}
.form-wrap {
  padding: 43px 32px;
  width: 710px;
  background: #ffffff;
  border-radius: 8px;
  font-size: 24px;
  width: 100%;
  .bindcard-wrap {
    display: flex;
    align-items: center;
    font-size: 32px;
    font-weight: 600;
    color: #262626;
    padding-bottom: 30px;
    margin-bottom: 34px;
    border-bottom: 1px solid #eaeef3;
    img {
      width: 56px;
      height: 56px;
      margin-right: 19px;
    }
  }
  .title {
    margin-left: 8px;
    font-size: 32px;
    color: #8c8c8c;
    margin-bottom: 8px;
  }
  .money-wrap {
    height: 90px;
    display: flex;
    font-weight: 500;
    color: #000000;
    align-items: center;
    img {
      width: 26px;
      height: 34px;
      margin-right: 13px;
    }
    .rmb-input {
      display: flex;
      align-items: center;
      input {
        height: 64px;
        font-size: 64px;
        line-height: 64px;
        font-weight: 500;
        color: #000000;
        width: 460px;
        padding: 13px 0;
        box-sizing: content-box;
      }
      .btn-out {
        margin-left: 6px;
        color: #2b6ddfff;
        font-size: 28px;
      }
    }
  }
  .tip {
    font-size: 20px;
    color: red;
    margin-bottom: 19px;
  }
  .desc {
    color: #8c8c8c;
    font-size: 28px;
  }
  .error {
    color: red;
  }
}
.bottom-box {
  margin-top: 450px;
  text-align: center;
  .submit-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 42px;
    .content {
      color: #ffffff;
      font-size: 32px;
      width: 360px;
      height: 90px;
      background: #fd9b21;
      border-radius: 8px;
      padding-top: 23px;
    }
  }
  .cancel-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 42px;
    .content {
      color: #ffffff;
      font-size: 32px;
      width: 360px;
      height: 90px;
      background: #d9d9d9;
      border-radius: 8px;
      padding-top: 23px;
    }
  }
  .desc {
    color: #8c8c8c;
    font-size: 24px;
    text-align: left;
    a {
      color: #2b6ddf;
    }
  }
}
.van-dialog {
  background: #ffffff;
  width: 710px;
  padding-bottom: 60px;
  padding-top: 40px;
  /deep/.van-dialog__header {
    padding-top: 20px;
    font-size: 36px;
    font-weight: 500;
    color: #000000;
    // margin-bottom: 30px;
  }
  .box {
    width: 710px;
    height: 487px;
    background: #ffffff;
    border-radius: 8px;
    .code-title {
      padding: 41px 49px 26px 49px;
      color: #262626;
      font-size: 34px;
    }
    .code-desc {
      width: 100%;
      text-align: center;
      color: #8c8c8c;
      font-size: 28px;
      margin-bottom: 65px;
    }
    .bottom-desc {
      width: 100%;
      margin-top: 90px;
      text-align: center;
      color: #8c8c8c;
      font-size: 24px;
      .btn-code {
        color: #2b6ddfff;
      }
    }
  }
  .submit-btn {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 90px;
    .content {
      width: 360px;
      height: 90px;
      background: #fd9b21;
      border-radius: 8px;
      color: #ffffff;
      text-align: center;
      font-size: 32px;
      padding-top: 23px;
    }
  }
  /deep/.van-number-keyboard {
    margin-top: 300px;
  }
  .numberInputWrap {
    width: 648px;
    height: 100px;
    overflow: hidden;
    margin: auto;
    position: relative;
  }
  /deep/ .vue_input_code .input > span {
    border: none;
  }
  .numberInputWrap {
    /deep/ div.input {
      position: relative;
      &::after {
        display: block;
        content: '';
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 6px;
        background-image: linear-gradient(
          90deg,
          white 0,
          white 25%,
          #ebedf0 25%,
          #ebedf0 75%,
          white 75%,
          white 100%
        );
        background-size: 108px 6px;
        background-repeat: repeat-x;
        background-position: left bottom;
      }
    }
  }
}
</style>
